import React, { useState } from 'react';
// 1. اضافه کردن EffectFade به ایمپورت ماژول‌ها
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
// 2. ایمپورت استایل افکت محو شدن
import 'swiper/css/effect-fade';

import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';
import Zoom from 'yet-another-react-lightbox/plugins/zoom';

const ProductGallery = ({ images }) => {
    const [open, setOpen] = useState(false);
    const [index, setIndex] = useState(0);

    const handleClick = (i) => {
        setIndex(i);
        setOpen(true);
    };

    return (
        <>
            <Swiper
                // 3. اضافه کردن EffectFade به لیست ماژول‌ها
                modules={[Navigation, Pagination, Autoplay, EffectFade]}
                navigation
                pagination={{ clickable: true }}

                effect="fade"
                fadeEffect={{ crossFade: true }}

                spaceBetween={0}
                slidesPerView={1}
                autoplay={{
                    delay: 3000,
                    disableOnInteraction: false,
                }}
            >
                {images.map((img, i) => (
                    <SwiperSlide key={i}>
                        <img
                            src={img}
                            alt={`Product ${i}`}
                            style={{ width: '100%', cursor: 'pointer', display: 'block' }} // display: block برای حذف فاصله اضافی زیر عکس
                            onClick={() => handleClick(i)}
                        />
                    </SwiperSlide>
                ))}
            </Swiper>

            <Lightbox
                open={open}
                close={() => setOpen(false)}
                index={index}
                slides={images.map((img) => ({ src: img }))}
                plugins={[Zoom]}
            />
        </>
    );
};

export default ProductGallery;
